import { Component, Inject, Optional, OnInit } from '@angular/core';
import { MatDatepickerInputEvent, MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as moment from 'jalali-moment';
import { JournalEntry } from '../../../models/Txn_JournalEntry';


@Component({
  selector: 'app-journal-status-edit',
  templateUrl: './journal-status-edit.component.html',
  styleUrls: ['./journal-status-edit.component.css']
})
export class JournalStatusEditComponent implements OnInit {
  trn_ref_no: string;
  remark: string;
  trn_amount: any;
  value_date: Date;
  id: number;  

  this_journal: JournalEntry = {
    documentNo: '',
    value_date: null,
    trn_ref_no: '',
    userId: '',
    branchId: 0,
    statusId: 2,
    branchTitle: '',
    statusTitle: '',
    isPrint: false,

    module: "FT",
    event_sr_no: 2,
    eventName: "INIT",
    ac_entry_sr_no: 0,
    ac_branch: "000",
    GL_Code: "IN_ST_ED_FEE",
    drcr_ind: "CR",
    trn_code: "AAT",
    trn_amount: 0,
    trn_date: new Date(),
    financial_cycle: "",
    period_code: "",
    batch_no: "",
    MakerID: "",
    CheckerID: "",
    auth_stat: "",
    delete_stat: "",
    product: "JREN",
    external_ref_no: "",
    entry_seq_no: 0,
    remarks: "",
  }

  constructor(
    public dialogRef: MatDialogRef<JournalStatusEditComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    console.log(data);
     
    this.trn_ref_no = data.trn_ref_no;
    this.value_date = new Date(data.value_date);
    this.remark = data.remark;

    this.statusId = data.statusId;
  }
  DateChanged(event: MatDatepickerInputEvent<moment.Moment>) {
    var _pdate = moment(event.value).format('jYYYY-jMM-jDD');
    var _date = moment.from(_pdate, 'fa').format('YYYY-MM-DD');
    this.value_date = new Date(_date);
    console.log(this.value_date);
    //this.fromDate_DariDate = _pdate;
  }

  statusId: number = 1;
  updateInvoice() {
    this.this_journal.statusId = this.statusId;
    this.this_journal.remarks = this.remark;
    this.this_journal.value_date = this.value_date
    this.this_journal.trn_ref_no = this.trn_ref_no;
    this.dialogRef.close({ event: 'close', data: this.this_journal });
  }

  closeDialog() {
    this.dialogRef.close({ event: 'close', data: this.this_journal });
  }

  ngOnInit() {

  }
}



// WEBPACK FOOTER //
// ./src/app/components/management/journal-status-edit/journal-status-edit.component.ts